<div class="row">
  @if (
    configuration().leftTable.search || configuration().leftTable.addAllButton
  ) {
    <div class="col-12">
      <div class="col-12 col-lg-6">
        <div class="mb-3 d-flex flex-row">
          @if (configuration().leftTable.search; as search) {
            <input
              class="form-control"
              type="text"
              [formControl]="searchControl"
              [placeholder]="search.placeholder | translate"
            />
          }
          @if (configuration().leftTable.addAllButton; as addAllButton) {
            <button
              class="icon-btn icon-btn-lg ms-3 flex-shrink-0"
              [ngbTooltip]="addAllButton.tooltip | translate"
              triggers="hover"
              (click)="addAll($event)"
              [disabled]="filteredLeftRows().length === 0"
            >
              <i [class]="addAllButton.icon || 'fa-light fa-cubes'"></i>
            </button>
          }
        </div>
      </div>
    </div>
  }
  <div class="col-12 col-lg-6 d-flex flex-column">
    <div class="data-table-container flex-grow-1 overflow-auto">
      <app-data-table [configuration]="leftTableConfiguration" />
    </div>
  </div>
  <div class="col-12 col-lg-6 d-flex flex-column mt-3 mt-lg-0">
    <div class="data-table-container flex-grow-1 overflow-auto">
      <app-data-table [configuration]="rightTableConfiguration" />
    </div>
  </div>
</div>
